import clsx from 'clsx';

/**
 * Editorial frame around a chart: title, optional subtitle/actions, hairline border.
 * @param {{ title: string, subtitle?: string, actions?: React.ReactNode, className?: string, children: React.ReactNode }} props
 */
export function ChartCard({ title, subtitle, actions, className, children }) {
  return (
    <section className={clsx('chart-card', className)}>
      <header className="chart-card-header">
        <div>
          <h3 className="chart-card-title">{title}</h3>
          {subtitle && <p className="chart-card-subtitle">{subtitle}</p>}
        </div>
        {actions}
      </header>
      <div className="chart-card-body">{children}</div>
    </section>
  );
}
